import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

export const useFirestore = () => {
  const { firestore } = useContext(AuthContext);
  return firestore;
};
